import React, { useState, useEffect } from "react";
import { db, storage } from "../firebase"; // Assuming you have set up Firebase
import { addDoc, collection, query, where, getDocs } from "firebase/firestore";
import { ref, deleteObject, listAll, getDownloadURL } from "firebase/storage";
import { Container, Row, Col, Card } from "react-bootstrap";
import { formatPhoneNumber } from "../functions/formatFunctions";
import StarRating from "../components/StarRating";
import ArtistsImages from "../components/ArtistsImages";

const ArtistsList = ({ user }) => {
  const [artists, setArtists] = useState([]);
  const [artistUrl, setArtistUrl] = useState([]);
  const [artistFolder, setArtistFolder] = useState([]);
  console.log(user);

  useEffect(() => {
    // Fetch data from Firestore's 'artists' collection
    const fetchArtists = async () => {
      try {
        const artistRef = collection(db, "artists");
        const snapshot = await getDocs(artistRef); // Use getDocs
        // const snapshot = await artistRef.get();
        const artistList = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // const guestArtistList = artistList.filter(
        //   (artist) => artist.role === "guestArtist"
        // );

        const guestArtistList = artistList
          .filter((artist) => artist.role === "guestArtist")
          .sort((a, b) => a.last_name.localeCompare(b.last_name));

        // Sort the artistList alphabetically by last_name
        //artistList.sort((a, b) => a.last_name.localeCompare(b.last_name));
        setArtists(guestArtistList); //becomes 'artists' from state
        console.log("Artist List Array;", artistList);
        //******/ this could be a fetch function******
        //this makes an array of artist folders
        const formattedNames = artistList.map((artist) => {
          return artist.first_name + "_" + artist.last_name;
          //get a reference to artists in storage
        });
        const imagesListRef = ref(storage, `images/${formattedNames[0]}/`);
        const allImages = await listAll(imagesListRef);
        const urls = await Promise.all(
          allImages.items.map(async (item) => {
            const url = await getDownloadURL(item);
            setArtistUrl(urls);
            return url;
          })
        );
        setArtistUrl(urls);
        console.warn("ARTIST_LIST These are all the urls", urls);
      } catch (error) {
        console.error("Error fetching artists: ", error);
      }
    };

    {
      artistUrl && fetchArtists();
    }
  }, []);

  return (
    <Container className='whiteText'>
      <h1>Guest Artist Submissions</h1>
      <Row>
        {artists.map((artist) => (
          <Col key={artist.id} lg={12}>
            <Card className='user-card mb-4'>
              <Card.Body className='whiteText'>
                <Row>
                  <Col lg={"6"}>
                    <h2>
                      {artist.first_name} {artist.last_name}
                    </h2>
                    <ul className='no-indent'>
                      <li>
                        e:
                        <a
                          className='all-artists-link'
                          href={`mailto:${artist.email}`}>
                          {artist.email}
                        </a>
                      </li>
                      <li>
                        p:
                        <a
                          className='all-artists-link'
                          href={`tel:${artist.phone}`}>
                          {formatPhoneNumber(artist.phone)}
                        </a>
                      </li>
                      <li>
                        w:
                        <a
                          className='all-artists-link'
                          href={
                            artist.website.startsWith("http://") ||
                            artist.website.startsWith("https://")
                              ? artist.website
                              : `https://${artist.website}`
                          }
                          target='_blank'
                          rel='noopener noreferrer'>
                          {artist.website}
                        </a>
                        {/* <a
                          className='all-artists-link'
                          href={artist.website}
                          target='_blank'
                          rel='noopener noreferrer'>
                          {artist.website}
                        </a> */}
                      </li>
                      <li>Insta: {artist.instagram}</li>
                      <li>Facebook: {artist.facebook}</li>
                    </ul>
                  </Col>
                  <Col lg={"6"}>
                    <StarRating
                      artist={artist}
                      user={user}
                      className='mt-4 mb-5'
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <div className='image-frame mt-4'>
                      {artist &&
                      Array.isArray(artist.imageURLs) &&
                      artist.imageURLs.length > 0 ? (
                        artist.imageURLs.map((singleUrl, index) => (
                          <img
                            className='one-pix-border'
                            key={index}
                            src={singleUrl}
                            alt={`${index + 1}`}
                            loading='lazy'
                          />
                        ))
                      ) : (
                        <h5 className='margin-rl pt-2 pb-2'>
                          No images available
                        </h5>
                      )}
                    </div>
                  </Col>
                  <Col lg={12} className='mt-4'>
                    <h4>Bio:</h4> <p>{artist.bio}</p>
                  </Col>
                </Row>

                {/* <div className='image-frame mt-4'>
                  {artist &&
                  Array.isArray(artist.imageURLs) &&
                  artist.imageURLs.length > 0 ? (
                    artist.imageURLs.map((singleUrl, index) => (
                      <img
                        className='one-pix-border'
                        key={index}
                        src={singleUrl}
                        alt={`${index + 1}`}
                        loading='lazy'
                      />
                    ))
                  ) : (
                    <h5 className='margin-rl pt-2 pb-2'>No images available</h5>
                  )}
                </div> */}

                {/* Add other artist information here */}
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default ArtistsList;
